export function dropdown(ctx) {
    return {
        styles: {
            main: { ...ctx.pretty, radius: 5, text_font: 32, text_color: ctx.SCR_TEXT, padding: 0 },
            item_buttons: {
                bg_color:     ctx.SCR,
                border_color: ctx.BORDER,
                border_width: 2,
                radius:       5,
                text_color:   ctx.SCR_TEXT,
                padding:      0,
            },
            selected: { bg_color: ctx.indic },
        },
    };
}
